import { ClientError } from '~client/error/client-error';

/**
 * Represents an `ApiSauce` `CONNECTION_ERROR` or `NETWORK_ERROR` problem.
 */
export class ClientNetworkError extends ClientError {
  constructor() {
    super('A network error occurred while performing client request');
    Object.setPrototypeOf(this, ClientNetworkError.prototype);
  }
}



// WEBPACK FOOTER //
// /codebuild/output/src332225586/src/modules/client/src/error/client-network-error.ts